import { useMemo, useState } from "react";

import { SUPPORT_EMAIL } from "@/constants/common.constants";
import { env } from "@/env";

import {
  BrandColorContext,
  DEFAULT_PLATFORM_TITLE,
  DEFAULT_PRIMARY_COLOR,
} from "./BrandColorContext";

const hasDomainPlatform = !!env.domainPlatformMap[window.location.host];

export const BrandColorContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [brandColor, setBrandColor] = useState<string | null>(DEFAULT_PRIMARY_COLOR);
  const [title, setTitle] = useState(DEFAULT_PLATFORM_TITLE);
  const [lightLogo, setLightLogo] = useState<string | null>(null);
  const [darkLogo, setDarkLogo] = useState<string | null>(null);
  const [lightEmblem, setLightEmblem] = useState<string | null>(null);
  const [darkEmblem, setDarkEmblem] = useState<string | null>(null);
  const [favicon, setFavicon] = useState<string | null>(null);
  const [supportEmail, setSupportEmail] = useState(SUPPORT_EMAIL);
  const [isWhiteLabeled, setIsWhiteLabeled] = useState(false);
  const [isBrandingLoading, setIsBrandingLoading] = useState(hasDomainPlatform);

  const contextValue = useMemo(
    () => ({
      brandColor,
      setBrandColor,
      title,
      setTitle,
      lightLogo,
      darkLogo,
      setLightLogo,
      setDarkLogo,
      lightEmblem,
      darkEmblem,
      setLightEmblem,
      setDarkEmblem,
      favicon,
      setFavicon,
      supportEmail,
      setSupportEmail,
      isWhiteLabeled,
      setIsWhiteLabeled,
      isBrandingLoading,
      setIsBrandingLoading,
    }),
    [
      brandColor,
      darkEmblem,
      darkLogo,
      favicon,
      isBrandingLoading,
      isWhiteLabeled,
      lightEmblem,
      lightLogo,
      supportEmail,
      title,
    ]
  );

  return <BrandColorContext.Provider value={contextValue}>{children}</BrandColorContext.Provider>;
};
